<div class="persona-avatar" (click)="onChosen($event)" (keydown)="onKeydown($event)" tabindex="0">
  <se-po-persona-avatar
    avatarDataSize="500"
    headerDataSize="600"
    [headerSubtitle]="profile.relationship === 'self' && 'Account Owner' || undefined"
    [persona]="profile.persona"
    showGraduation="true">
    <div *ngIf="menuOptions" personaAvatarActions (click)="onActionClick($event)">
      <se-fe-icon-button [seFeMenuTrigger]="menuOptions.name" class="menuIcon">
        <se-fe-icon
          seFeDataName="more"
          seFeDataSize="700"
          seFeDataColor="gray-700"
          seFeDataAriaLabel="more">
        </se-fe-icon>
      </se-fe-icon-button>
      <se-fe-menu
        [seFeDataOptions]="menuOptions">
      </se-fe-menu>
    </div>
  </se-po-persona-avatar>
</div>
